module.exports = __webpack_public_path__ + "img/hangkong.6712506e.png";